// material-ui
import { Button, ButtonBase, Card, CardActionArea, CardActions, CardHeader, CardMedia, Grid, Stack, Typography } from '@mui/material';
import userAccessService from 'services/userAccess';

// project import
import MainCard from 'components/MainCard';
import { getProduct, getUserData, handleAsyncCall, useLocalStorage } from 'utils/common';
import { sessionConfig } from 'utils/constant';
import { useEffect, useState } from 'react';
import useMain from 'hooks/useMain';
import { completeMenuList, setMenuList, setShowDrawer } from 'store/reducers/menu';
import projImg from 'assets/images/proj/contract/kch.png';
import { setState } from 'store/reducers/authentication';
import { rFetchProjectList } from 'store/reducers/comModule';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useTheme } from '@mui/material/styles';

// ==============================|| SAMPLE PAGE ||============================== //

const ProjectPage = () => {
  const { setStorage } = useLocalStorage();
  const { t, useNavigate, dispatch, useSelector, upperCaseLang } = useMain();
  const navigate = useNavigate();
  const projectList = useSelector((s) => s.comModule.projects);
  const theme = useTheme();

  const handleProjUpdate = (projId) => {
    dispatch(setState(['project', projId]));
    setStorage(sessionConfig.project, projId);
    navigate('/dashboard');
  };

  useEffect(() => {
    if (!getProduct()?.Id) {
      navigate('/product');
    }
  }, [getProduct()]);

  useEffect(() => {
    if (!_.isEmpty(getUserData())) {
      dispatch(setMenuList(completeMenuList));
      dispatch(
        rFetchProjectList({
          successCb: (res) => {
            if (res.data.length === 1) {
              handleProjUpdate(res.data[0]);
            }
          }
        })
      );
    }
  }, []);

  useEffect(() => {
    if (projectList.length === 1) {
      handleProjUpdate(projectList[0]);
    }
  }, [projectList]);

  // return (
  //   <Grid container spacing={2} width="100%">
  //     {projectList.map(function ({ ProjId, ProjName, ProjCode, SubContCode, ...rest }, i) {
  //       return (
  //         <Grid item sm={6} md={4} key={`${ProjId}`}>

  //           <MainCard sx={{cursor: 'pointer'}}>
  //             <CardActions
  //                   onClick={(e) => {
  //                   handleProjUpdate(projectList[i]);
  //                 }}
  //                 sx={{display:'flex', justifyContent:'space-between'}}
  //             >
  //             <Stack>
  //               <Stack>
  //               <CardMedia component="img" height="194" src={projImg} alt="site image"/>
  //               </Stack>
  //               <Stack direction='row' justifyContent='space-between'>
  //                 <CardHeader
  //                   sx={{
  //                     '.MuiCardHeader-subheader': {
  //                       height: '3.14em',
  //                       textOverflow: 'ellipsis',
  //                       overflow: 'hidden',
  //                       'WebkitLineClamp': '2',
  //                       'WebkitBoxOrient': 'vertical',
  //                       display: '-webkit-box'
  //                     }
  //                   }}
  //                   title={`${ProjCode} / ${ProjName}`}
  //                   subheader={t(rest[`ContractDesc${upperCaseLang}`])}
  //                 />
  //                 <Grid sx={{
  //               display:'flex',
  //               justifyContent: 'center',
  //               alignItems: 'center'
  //               }}>
  //                 <KeyboardArrowRightIcon sx={{color:theme.palette.primary.light}}/>
  //                 </Grid>

  //               </Stack>
  //             </Stack>
  //             </CardActions>

  //           </MainCard>

  //         </Grid>
  //       );
  //     })}
  //   </Grid>
  // );

  return (
    <Grid container spacing={2} width="100%">
      {projectList.map(function ({ ProjId, ProjName, ProjCode, SubContCode, ...rest }, i) {
        return (
          <Grid item sm={6} md={4} key={`${ProjId}`}>
            <CardActionArea
              onClick={(e) => {
                handleProjUpdate(projectList[i]);
              }}
              sx={{ cursor: 'pointer', '& .MuiCardActionArea-focusHighlight': { background: 'transparent' } }}
            >
              <Card
                sx={{
                  borderRadius: '20px',
                  borderColor: theme.palette.mode === 'dark' ? theme.palette.divider : theme.palette.grey.A800,
                  boxShadow: theme.customShadows.z1,
                  ':hover': {
                    boxShadow: theme.customShadows.primary
                  }
                }}
              >
                <CardMedia component="img" height="194" src={projImg} alt="site image" />
                <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
                  <CardHeader
                    sx={{
                      '.MuiCardHeader-subheader': {
                        height: '3.14em',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        WebkitLineClamp: '2',
                        WebkitBoxOrient: 'vertical',
                        display: '-webkit-box'
                      }
                    }}
                    title={`${ProjCode} / ${ProjName}`}
                    subheader={t(rest[`ContractDesc${upperCaseLang}`])}
                  />

                  {/* <Button
                  variant="outlined"
                  onClick={(e) => {
                    handleProjUpdate(projectList[i]);
                  }}
                >
                  {t('BTN_SELECT')}
                </Button> */}
                  <Grid
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <ArrowForwardIosIcon sx={{ color: theme.palette.primary.light }} />
                  </Grid>
                </Stack>
              </Card>
            </CardActionArea>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default ProjectPage;
